import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [{ value: 'au', label: 'Australia' }],
});
